export const normalizeSearchText = (value) => {
  return String(value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
};

export const normalizedIncludes = (value, query) => {
  return normalizeSearchText(value).includes(normalizeSearchText(query));
};

export const filterByNormalizedText = (items, query, getText = (item) => item) => {
  const normalizedQuery = normalizeSearchText(query);

  if (!normalizedQuery) {
    return [...items];
  }

  return items.filter((item) => normalizeSearchText(getText(item)).includes(normalizedQuery));
};
